import course from '@images/homepage/home_icon_course.png'
import developDath from '@images/homepage/home_icon_jobDev.png'
import exam from '@images/homepage/home_icon_exam.png'
import studyMap from '@images/homepage/home_icon_studymap.png'
import messageTips from '@images/homepage/icon_message_tips.png'
import training from '@images/homepage/icon_training@2x.png'
import questionnaire from '@images/homepage/icon_questionnaire@2x.png'
import practiceTrain from '@images/homepage/icon-practicetask@2x.png'
import work from '@images/homepage/icon_work@2x.png'
import trainingProject from '@images/homepage/icon_trainingProject.png'
import myBoughtCourse from '@images/homepage/icon_myBoughtCourse.png'
import learnCard from '@images/homepage/icon_learnCard.png'
import liveRoom from '@images/homepage/icon_liveRoom.png'
import examLibrary from '@images/homepage/icon-examLibrary.png'

import { createStyles } from '@zn-material-ui'
export default () =>
  createStyles({
    card: {
      width: '100%',
      minWidth: 310,
      fontSize: '14px',
      color: '#666',
      boxShadow: 'none',
      marginBottom: '10px',
    },
    title: {
      fontSize: 16,
      color: '#000',
      borderBottom: '1px solid #E5E5E5',
      height: 50,
      boxSizing: 'border-box',
      lineHeight: '50px',
      paddingLeft: '26px',
      letterSpacing: 'initial !important',
    },
    content: {
      padding: 0,
    },
    iconBar: {
      padding: '24px 28px',
      display: 'flex',
      flexDirection: 'column',
      '& a': {
        display: 'inline-block',
        margin: '0',
      },
      '& a:hover': {
        textDecoration: 'none',
      },
    },
    entryWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 10,
    },
    iconItem: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      alignItems: 'center',
      fontSize: '14px',
      color: '#666666',
      margin: '8px 0 0',
      letterSpacing: 'initial !important',
      textAlign: 'center',
      width: '85px',
    },
    icon: {
      display: 'inline-block',
      width: 50,
      height: 50,
      marginBottom: '2px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    },
    count: {
      position: 'absolute',
      background: `url(${messageTips}) no-repeat`,
      width: '22px',
      height: '22px',
      display: 'inline-block',
      color: '#fff',
      fontSize: '12px',
      right: '8px',
      lineHeight: '22px',
      textAlign: 'center',
      top: '-10px',
      '&:first-child': {
        color: 'red',
      },
    },
    cardTitle: {
      width: '100%',
      wordWrap: 'break-word',
      wordBreak: 'normal',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    },
    course: {
      backgroundImage: `url(${course})`,
    },
    developDath: {
      backgroundImage: `url(${developDath})`,
    },
    exam: {
      backgroundImage: `url(${exam})`,
    },
    studyMap: {
      backgroundImage: `url(${studyMap})`,
    },
    myTrainingClass: {
      backgroundImage: `url(${training})`,
    },
    myQuestionnaire: {
      backgroundImage: `url(${questionnaire})`,
    },
    practiceTrain: {
      backgroundImage: `url(${practiceTrain})`,
    },
    work: {
      backgroundImage: `url(${work})`,
    },
    trainingProject: {
      backgroundImage: `url(${trainingProject})`,
    },
    myBoughtCourse: {
      backgroundImage: `url(${myBoughtCourse})`,
    },
    learnCard: {
      backgroundImage: `url(${learnCard})`,
    },
    liveRoom: {
      backgroundImage: `url(${liveRoom})`,
    },
    examLibrary: {
      backgroundImage: `url(${examLibrary})`
    },
    seat: {
      width: 85,
      height: 85,
    },
  })
